// extracted by mini-css-extract-plugin
module.exports = {"title":"RefreshDialog_title__3a8__","close":"RefreshDialog_close__ZA_e2","content":"RefreshDialog_content__l1wiG"};